import $ from 'jquery';

import { bindClearButton, bindSearchDropdowns } from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`#search-form select`),
  clearButton: $(`#clear-button`),
};

export default class CarrierServiceOptions {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`#carrier-service-options.index`).length === 0) {
      return undefined;
    }

    return new CarrierServiceOptions();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
    bindClearButton(this.searchFormElements);
  }
}
